// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"e1346a10","395":"c7f01510","855":"87742c5d","928":"64a67cb4"}[chunkId] + ".chunk.js";
};